import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

import { env } from 'src/env/client.mjs'
import { NotFound } from 'src/pages/404/404'
import { trpc } from 'src/utils/trpc'

const ViewProjectPage: NextPage = () => {
  const router = useRouter()
  const { uri } = router.query as { uri: string }

  const { data, isLoading } = trpc.useQuery([
    'projects.getProjectByUri',
    { uri }
  ])

  if (isLoading) return null
  if (!data) return <NotFound />

  return (
    <SanityContentPage
      slug='project-detail'
      title={data.Name}
      metaTitle={data.Name}
      metaDescription={data.Description?.slice(0, 250).concat('...') || ''}
      image={`${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${data.Hero}`}
      showBreadcrumbs={false}
    />
  )
}

export default ViewProjectPage
